// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#date-picker .react-datepicker-popper {
  position: fixed !important;
}

#date-picker .react-datepicker-wrapper {
  width: 100%;
}

#date-picker .react-datepicker {
  width: 240px;
  border: 1px solid #637768;
}

#date-picker .react-datepicker__header {
  border-bottom: 1px solid #637768;
  background-color: white;
}

#date-picker .react-datepicker__day-names {
  margin-bottom: -10px;
}

#date-picker .react-datepicker__day {
  line-height: 22px;
  user-select: none;
}

#date-picker .react-datepicker__day--outside-month {
  color: #859989 !important;
}

#date-picker .react-datepicker__day--selected:hover,
#date-picker .react-datepicker__day--selected {
  background-color: transparent;
  border: 2px solid #375844 !important;
  font-weight: bold;
  color: #375844;
}

#date-picker .react-datepicker__month-text:hover {
  background-color: #f1f3e7;
}

#date-picker .react-datepicker__month-text--selected:hover,
#date-picker .react-datepicker__month-text--selected {
  background-color: #375844 !important;
  color: white !important;
  font-weight: bold;
}

#date-picker .react-datepicker-year-header {
  padding: 12px;
  color: #637768;
  border-bottom-color: #637768;
}

#date-picker .react-datepicker__day-name {
  color: #637768;
  line-height: 24px;
}

#date-picker .react-datepicker__current-month {
  color: #637768;
  border-bottom: 1px solid #637768;
  height: 20px;
  margin-top: 0;
  padding-bottom: 5px;
}

#date-picker .react-datepicker__month-container {
  width: 100%;
}

#date-picker .react-datepicker__month-wrapper {
  padding: 6px;
}

#date-picker .react-datepicker__input-time-container {
  margin: -14px 0 0 0;
}

#date-picker .react-datepicker-popper {
  z-index: 100;
}

#date-picker
  .react-datepicker__input-time-container
  .react-datepicker-time__input-container
  .react-datepicker-time__input {
  margin-left: 0;
  display: block;
}

#date-picker .react-datepicker__input-time-container .react-datepicker-time__input-container {
  display: block;
}

#date-picker .react-datepicker__day {
  border: 2px solid transparent;
  border-radius: 50%;
  color: #375844;
  width: 23px;
}

#date-picker .react-datepicker__day--disabled {
  color: #ccc !important;
  border: 2px solid transparent !important;
  cursor: not-allowed;
}

#date-picker .react-datepicker__day--today {
  background-color: transparent;
}

#date-picker .react-datepicker__day:hover {
  background-color: transparent;
  border: 2px solid #375844;
  font-weight: bold;
  color: #375844;
}

#date-picker .react-datepicker__navigation-icon {
  top: 0;
}

#date-picker .react-datepicker__navigation-icon::before {
  border-color: #375844;
}

#date-picker .react-datepicker__day--in-range,
#date-picker .react-datepicker__day--in-range:hover,
#date-picker .react-datepicker__day--in-selecting-range,
#date-picker .react-datepicker__day--in-selecting-range:hover {
  background-color: #f1f3e7 !important;
  border-color: #f1f3e7 !important;
}
`, "",{"version":3,"sources":["webpack://./../common/src/components/base/DatePickerNew/styles.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,6BAA6B;EAC7B,oCAAoC;EACpC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;EACpC,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;;;;EAIE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;EAIE,oCAAoC;EACpC,gCAAgC;AAClC","sourcesContent":["#date-picker .react-datepicker-popper {\n  position: fixed !important;\n}\n\n#date-picker .react-datepicker-wrapper {\n  width: 100%;\n}\n\n#date-picker .react-datepicker {\n  width: 240px;\n  border: 1px solid #637768;\n}\n\n#date-picker .react-datepicker__header {\n  border-bottom: 1px solid #637768;\n  background-color: white;\n}\n\n#date-picker .react-datepicker__day-names {\n  margin-bottom: -10px;\n}\n\n#date-picker .react-datepicker__day {\n  line-height: 22px;\n  user-select: none;\n}\n\n#date-picker .react-datepicker__day--outside-month {\n  color: #859989 !important;\n}\n\n#date-picker .react-datepicker__day--selected:hover,\n#date-picker .react-datepicker__day--selected {\n  background-color: transparent;\n  border: 2px solid #375844 !important;\n  font-weight: bold;\n  color: #375844;\n}\n\n#date-picker .react-datepicker__month-text:hover {\n  background-color: #f1f3e7;\n}\n\n#date-picker .react-datepicker__month-text--selected:hover,\n#date-picker .react-datepicker__month-text--selected {\n  background-color: #375844 !important;\n  color: white !important;\n  font-weight: bold;\n}\n\n#date-picker .react-datepicker-year-header {\n  padding: 12px;\n  color: #637768;\n  border-bottom-color: #637768;\n}\n\n#date-picker .react-datepicker__day-name {\n  color: #637768;\n  line-height: 24px;\n}\n\n#date-picker .react-datepicker__current-month {\n  color: #637768;\n  border-bottom: 1px solid #637768;\n  height: 20px;\n  margin-top: 0;\n  padding-bottom: 5px;\n}\n\n#date-picker .react-datepicker__month-container {\n  width: 100%;\n}\n\n#date-picker .react-datepicker__month-wrapper {\n  padding: 6px;\n}\n\n#date-picker .react-datepicker__input-time-container {\n  margin: -14px 0 0 0;\n}\n\n#date-picker .react-datepicker-popper {\n  z-index: 100;\n}\n\n#date-picker\n  .react-datepicker__input-time-container\n  .react-datepicker-time__input-container\n  .react-datepicker-time__input {\n  margin-left: 0;\n  display: block;\n}\n\n#date-picker .react-datepicker__input-time-container .react-datepicker-time__input-container {\n  display: block;\n}\n\n#date-picker .react-datepicker__day {\n  border: 2px solid transparent;\n  border-radius: 50%;\n  color: #375844;\n  width: 23px;\n}\n\n#date-picker .react-datepicker__day--disabled {\n  color: #ccc !important;\n  border: 2px solid transparent !important;\n  cursor: not-allowed;\n}\n\n#date-picker .react-datepicker__day--today {\n  background-color: transparent;\n}\n\n#date-picker .react-datepicker__day:hover {\n  background-color: transparent;\n  border: 2px solid #375844;\n  font-weight: bold;\n  color: #375844;\n}\n\n#date-picker .react-datepicker__navigation-icon {\n  top: 0;\n}\n\n#date-picker .react-datepicker__navigation-icon::before {\n  border-color: #375844;\n}\n\n#date-picker .react-datepicker__day--in-range,\n#date-picker .react-datepicker__day--in-range:hover,\n#date-picker .react-datepicker__day--in-selecting-range,\n#date-picker .react-datepicker__day--in-selecting-range:hover {\n  background-color: #f1f3e7 !important;\n  border-color: #f1f3e7 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
